var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid p-3 p-md-4"},[_vm._m(0),_c('SupplyPointMobileList')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center mb-4 mb-md-5"},[_c('h3',{staticClass:"font-weight-600 text-dark mb-0"},[_c('i',{staticClass:"fad fa-house text-primary fa-fw mr-3"}),_vm._v("Odběrná místa ")])])
}]

export { render, staticRenderFns }